<template>
  <div>
    <v-container>
      <v-row justify-space-between>
        <v-container px-0 pb-0>
                        <v-row justify-space-between>
                      <v-col>
            <v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
              <Keys />
            </v-card>
          </v-col>
        </v-row>
      </v-container>

      <v-container px-0 pb-0>
                        <v-row justify-space-between>
                            <v-col>
             <v-card class="pa-2 mr-2" flat min-height="340px" height="100%">
                <HostsItem />
              </v-card>
            </v-col>
                        </v-row>
                    </v-container>
        </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import HostsItem from "@/components/HostsItem";
import Keys from "@/components/Keys";

export default {
  components: {
        HostsItem,
    Keys,
  },
  computed: {
    ...mapState({
      user: state => state.account.user,
      currencies: state => state.account.currencies
    })
  },
  methods: {
  },
  mounted() {
  },
  data: () => ({
    loading: false,
  })
};
</script>

<style>
</style>